/**
 * Annual “gold special” campaign (discounted annual SKUs + annual-only UX on /pricing).
 *
 * When `true`:
 * - Pricing page hides the monthly/annual switch and keeps users on annual.
 * - `PricingPackeges` uses `goldSpecial` → `ANNUAL_DISCOUNT_50` products for eligible users.
 * - Hero promo copy + countdown on `/pricing` (via `annualPromo` state from the grid).
 * - Site header shows the annual discount banner for free Hexomatic users (links to `/pricing/`).
 *
 * When `false`:
 * - Normal monthly/annual toggle and standard product intervals on `/pricing`.
 *
 * Flip this to `true` to re-run the same promotion without re-threading one-off code.
 */
export const PRICING_ANNUAL_GOLD_SPECIAL_PROMO_ACTIVE = false;

export const ANNUAL_PROMO_97097_PATH = '/promo97097';
export const ANNUAL_PROMO_97097_INTERVAL = 'ANNUAL_PROMO_97097';
/** 11:59 PM ET on September 30, 2026. */
export const ANNUAL_PROMO_97097_END = 'Oct 1 2026 03:59:00 GMT';

export const isAnnualPromo97097Ended = () => Date.now() >= new Date(ANNUAL_PROMO_97097_END).getTime();
